import { IPartnerListItem } from '../interfaces/user';

/** How many letters stand in for the logo while the account has none. */
const INICIAIS_MAX = 3;

/**
 * The account (partner) picked in the unified login, as every screen shows it. The name and
 * the logo are registered in the uMode dashboard: CosturAI only reads them.
 */
export interface IContaAtiva {
  /** Empty while the account list has not arrived: the product then shows its own name alone. */
  nome: string;
  /** `null` when the account has no logo: the initials answer for it. */
  logoUrl: string | null;
  /** Up to three letters standing in for the logo. */
  iniciais: string;
}

/**
 * One word gives its first letters ("DRO" stays "DRO"), several give their initials
 * ("DRO Confecções" becomes "DC"). A single letter would read as a bullet, and the whole
 * name would not fit the square the header reserves.
 */
export function iniciaisDe(fonte: string): string {
  const palavras = fonte
    .trim()
    .split(/\s+/)
    .filter((palavra) => palavra !== '');
  if (palavras.length === 0) {
    return '';
  }
  if (palavras.length === 1) {
    return palavras[0].slice(0, INICIAIS_MAX).toUpperCase();
  }
  return palavras
    .slice(0, 2)
    .map((palavra) => palavra[0])
    .join('')
    .toUpperCase();
}

/** The active account out of the session's account list; empty when it is not in the list. */
export function contaAtiva(
  partnersList: ReadonlyArray<IPartnerListItem> | null | undefined,
  partnerId: string | null | undefined,
): IContaAtiva {
  const partner = (partnersList ?? []).find((item) => item.partnerId === partnerId);
  const nome = (partner?.partnerName ?? '').trim();
  const logo = partner?.partnerLogoImage?.s200 || partner?.partnerLogoImage?.s600 || '';

  return { nome, logoUrl: logo === '' ? null : logo, iniciais: iniciaisDe(nome) };
}
